import { Users } from "lucide-react";
import type { FormData } from "../types";

interface SettingsSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
}

export function SettingsSection({
  formData,
  onFormChange,
}: SettingsSectionProps) {
  return (
    <>
      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: "var(--text-primary)" }}
        >
          Número de Alunos
        </label>
        <div className="flex items-center gap-2">
          <Users
            className="w-5 h-5"
            style={{ color: "var(--text-tertiary)" }}
          />
          <input
            type="number"
            min="1"
            max="50"
            value={formData.studentsCount}
            onChange={(e) =>
              onFormChange("studentsCount", parseInt(e.target.value) || 30)
            }
            className="flex-1 p-3 border rounded-lg focus:outline-none focus:ring-2 transition bg-(--input-bg)"
            style={{
              borderColor: "var(--border-color)",
              color: "var(--text-primary)",
            }}
          />
        </div>
      </div>

      <div className="md:col-span-2">
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: "var(--text-primary)" }}
        >
          Configurações Adicionais
        </label>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <label
            className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-(--bg-accent) transition"
            style={{ borderColor: "var(--border-color)" }}
          >
            <input
              type="checkbox"
              checked={formData.includeActivities}
              onChange={(e) =>
                onFormChange("includeActivities", e.target.checked)
              }
              className="w-4 h-4 rounded"
            />
            <div>
              <p
                className="font-medium text-sm"
                style={{ color: "var(--text-primary)" }}
              >
                Incluir Atividades
              </p>
              <p className="text-xs" style={{ color: "var(--text-tertiary)" }}>
                Exercícios e dinâmicas
              </p>
            </div>
          </label>

          <label
            className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-(--bg-accent) transition"
            style={{ borderColor: "var(--border-color)" }}
          >
            <input
              type="checkbox"
              checked={formData.includeMaterials}
              onChange={(e) =>
                onFormChange("includeMaterials", e.target.checked)
              }
              className="w-4 h-4 rounded"
            />
            <div>
              <p
                className="font-medium text-sm"
                style={{ color: "var(--text-primary)" }}
              >
                Lista de Materiais
              </p>
              <p className="text-xs" style={{ color: "var(--text-tertiary)" }}>
                Recursos necessários
              </p>
            </div>
          </label>

          <label
            className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-(--bg-accent) transition"
            style={{ borderColor: "var(--border-color)" }}
          >
            <input
              type="checkbox"
              checked={formData.includeAssessment}
              onChange={(e) =>
                onFormChange("includeAssessment", e.target.checked)
              }
              className="w-4 h-4 rounded"
            />
            <div>
              <p
                className="font-medium text-sm"
                style={{ color: "var(--text-primary)" }}
              >
                Avaliação
              </p>
              <p className="text-xs" style={{ color: "var(--text-tertiary)" }}>
                Critérios de avaliação
              </p>
            </div>
          </label>
        </div>
      </div>
    </>
  );
}
